const modules = {
  en: () => import('./en.json'),
  de: () => import('./de.json'),
  es: () => import('./es.json'),
  fr: () => import('./fr.json'),
  it: () => import('./it.json'),
  pt: () => import('./pt.json'),
  uk: () => import('./uk.json'),
}

export async function loadCountries(locale) {
  const loader = modules[locale] ?? modules['en']
  const module = await loader()
  return module.default
}
